import { Pipe, PipeTransform } from '@angular/core';
import { filter as _filter } from 'lodash-es';

@Pipe({
  name: 'filterProperty',
  pure: false
})
export class FilterPropertyPipe implements PipeTransform {

  transform(items: any[], filter: Object): unknown {
    const filteredItems = _filter(items, filter);
    return filteredItems;
  }

}
